// removed by extract-text-webpack-plugin
module.exports = {"edit-demographics-header":"edit-demographics-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditDemographics/EditDemographics.scss
// module id = 5388
// module chunks = 1